import {
  Form as VeeForm,
  Field as VeeField,
  defineRule,
  ErrorMessage,
  configure,
} from "vee-validate";
import {
  required,
  min,
  max,
  alpha_spaces as alphaSpaces,
  email,
  min_value as minVal,
  max_value as maxVal,
  confirmed,
  not_one_of as excluded,
  image,
  mimes,
  size,
  numeric,
  url,
} from "@vee-validate/rules";

export default {
  install(app) {
    app.component("VeeForm", VeeForm);
    app.component("VeeField", VeeField);
    app.component("ErrorMessage", ErrorMessage);

    defineRule("required", required);
    defineRule("tos", required);
    defineRule("min", min);
    defineRule("max", max);
    defineRule("alpha_spaces", alphaSpaces);
    defineRule("email", email);
    defineRule("min_value", minVal);
    defineRule("max_value", maxVal);
    defineRule("passwords_mismatch", confirmed);
    defineRule("excluded", excluded);
    defineRule("country_excluded", excluded);

    defineRule("image", image);
    defineRule("mimes", mimes);
    defineRule("size", size);
    defineRule("numeric", numeric);
    defineRule("url", url);
    defineRule("ci_format", (value) => {
      if (!value) return true;
      const ciRegex = /^\d{7,8}$/;
      return ciRegex.test(value);
    });
    defineRule("complemento_format", (value) => {
      if (!value) return true;
      const complementoRegex = /^[0-9A-Za-z]{1,2}$/;
      return complementoRegex.test(value);
    });

    defineRule("rude_format", (value) => {
      if (!value) return true;
      const ciRegex = /^[a-zA-Z0-9]{8,20}$/;
      return ciRegex.test(value);
    });

    defineRule("rda_format", (value) => {
      if (!value) return true;
      const ciRegex = /^\d{1,11}$/;
      return ciRegex.test(value);
    });

    defineRule("phone_format", (value) => {
      if (!value) return true;
      const phoneRegex = /^[67]\d{7}$/;
      return phoneRegex.test(value);
    });

    defineRule("url_validation", (value) => {
      if (!value || value.trim() === "") return true;

      const trimmedValue = value.trim();
      const urlRegex =
        /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/ \w \.-]*)*\/?$/i;

      if (!urlRegex.test(trimmedValue)) {
        return "Debe ser una URL válida (ej: https://ejemplo.com)";
      }

      const valueToTest = trimmedValue.match(/^https?:\/\//)
        ? trimmedValue
        : `http://${trimmedValue}`;

      try {
        new URL(valueToTest);
        return true;
      } catch (error) {
        return "Debe ser una URL válida (ej: https://ejemplo.com)";
      }
    });

    defineRule("number", (value) => {
      if (!value) return true;
      return (
        (!isNaN(value) && !isNaN(parseFloat(value))) ||
        "Debe ser un número válido"
      );
    });

    defineRule("pattern", (value, [pattern]) => {
      if (!value) return true;
      const regex = new RegExp(pattern);
      return regex.test(value) || "El formato no es válido";
    });

    configure({
      generateMessage: (ctx) => {
        const messages = {
          required: `El campo es obligatorio.`,
          min: `La longitud del campo es demasiado corta.`,
          max: `La longitud del campo es demasiado larga.`,
          alpha_spaces: `El campo solo soporta caracteres y espacios.`,
          email: `El campo debe contener una dirección de correo válida.`,
          min_value: `El valor de ${ctx.field} debe ser mayor o igual a ${ctx.rule.params[0]}.`,
          max_value: `El valor de ${ctx.field} debe ser menor o igual a ${ctx.rule.params[0]}.`,
          excluded: `No se permite usar este valor para el campo **${ctx.field}**.`,
          country_excluded:
            "Debido a restricciones, no aceptamos usuarios de esta ubicación.",
          passwords_mismatch: "Las contraseñas no coinciden.",
          tos: "Debe aceptar los Términos de Servicio.",
          image: "Tipo de archivo no válido.",
          mimes: "Formato no aceptado.",
          size: `El tamaño del archivo debe ser menor a: ${ctx.rule.params[0]} KB`,
          numeric: `El campo solo acepta números.`,
          url: `Debe ser una dirección URL válida.`,
          ci_format: `El campo debe tener entre 7 y 8 dígitos.`,
          complemento_format: `Debe ser un complemento válido.`,
          rude_format: `El campo debe tener entre 8 y 20 dígitos.`,
          rda_format: `El campo debe tener entre 1 y 11 dígitos.`,
          phone_format: `Ingrese un número de celular válido.`,
          url_validation: `Debe ser una URL válida.`,
          number: `Debe ser un número válido.`,
          pattern: `El formato no es válido.`,
        };

        const message = messages[ctx.rule.name]
          ? messages[ctx.rule.name]
          : `The field ${ctx.field} is invalid.`;

        return message;
      },
      validateOnBlur: true,
      validateOnChange: true,
      validateOnInput: false,
      validateOnModelUpdate: true,
    });
  },
};
